module.exports = __webpack_public_path__ + "img/to_openspace_hover.a8b06397.png";